(function () {

    /**
     * Get interview module
     *
     * @type {angular.Module|module}
     */
    var interviewModule = angular.module('harriApp.interviewV2');

    /**
     * Interview manage availability form controller
     *
     * @param $scope
     * @param InterviewSettingsForm
     * @param InterviewCalendarForm
     * @param InterviewViewService
     * @param InterviewDataService
     * @param source
     * @param hUser
     * @constructor
     */
    var InterviewManageAvailabilityFormController = function (
        $scope,
        InterviewSettingsForm,
        InterviewCalendarForm,
        InterviewViewService,
        InterviewDataService,
        source,
        hUser,
        brandServices
    ) {

        var self = this;

        var viewService = InterviewViewService({});
        var interviewSetId;

        var isManageAvailability = true;
        var interviewOverlap;
        var autoInvitesCount;
        var _emitter = JarEventEmitter.call(self);

        var forms = new FormGroup();
        self.settingsForm = forms.addForm(InterviewSettingsForm($scope, viewService, isManageAvailability));
        self.calendarForm = forms.addForm(InterviewCalendarForm($scope, viewService, isManageAvailability));
        self.settingsForm.on('INTERVIEW_OVERLAP_CHANGED', function (tempInterviewOverlap) {
            if (self.isAQAAFServiceEnabled) {
                interviewOverlap = tempInterviewOverlap;
                updateAutoInviteMsg();
                $scope.$digest();
            }
        });

        self.autoInvitesCountChanged = function (tempAutoInvitesCount) {
            if (self.isAQAAFServiceEnabled) {
                autoInvitesCount = tempAutoInvitesCount;
                updateAutoInviteMsg();
                $scope.$digest();
            }
        };

        var updateSlotsOutsideInterviewWindowMsg = function () {
            var interviewWindow = getMinMaxWindow();
            var slotsValidation = InterviewDataService.validateSlots(interviewWindow.min, interviewWindow.max);
            self.confirmedSlotsOutsideInterviewWindow = slotsValidation.confirmedSlots;
            self.slotsOutsideInterviewWindow = slotsValidation.slots;
        };

        var handleSlotsOnWindowMoving = function () {
            updateSlotsOutsideInterviewWindowMsg();
            self.drawInterviewSchedule();
            updateSlotsOutsideInterviewWindowMsg();
        };

        self.calendarForm.on('INTERVIEW_WINDOW_UPDATED', function () {
            if (self.isAQAAFServiceEnabled) {
                var interviewSettings = self.job['interview_settings'] = self.job['interview_settings'] || {};
                interviewSettings['interview_window'] = parseInt(self.calendarForm.getInterviewWindow()) || 365;
                handleSlotsOnWindowMoving();
            }
        });

        self.autoInvitesAfterDaysChanged = function (tempAutoInviteAfterObj) {
            if (self.isAQAAFServiceEnabled) {
                var interviewSettings = self.job['interview_settings'] = self.job['interview_settings'] || {};
                var interviewAutoInviteSettings = interviewSettings['interview_auto_invite_settings'] = interviewSettings['interview_auto_invite_settings'] || {};
                interviewAutoInviteSettings['send_invitation_after_days_count'] = (!isNaN(tempAutoInviteAfterObj.days) ? tempAutoInviteAfterObj.days : 1);
                interviewAutoInviteSettings['send_invitation_mode'] = tempAutoInviteAfterObj.mode || '';
                handleSlotsOnWindowMoving();
            }
        };

        self.autoInvitesMessageChanged = function (autoInvitesMessage) {
            self.autoInviteMessage = autoInvitesMessage;
        };

        self.autoInvitesAttachmentsChanged = (attachments) => {
            self.autoInviteAttachments = attachments;
        }

        self.autoInviteInterviewCategoryChanged = (interviewCategory) => {
            self.autoInviteInterviewCategory = interviewCategory;
        }

        self.autoInviteInterviewVideoLinkChanged = (interviewVideoLink) => {
            self.autoInviteVideoLink = interviewVideoLink;
        }

        var getInterviewSetDetails = function () {

            var deferred = $q.defer();

            InterviewV2API.getInterviewSetDetails(self.brandId, self.job.id, interviewSetId)
                .then(function (response) {
                    var interviewSetData = response.interview_set;

                    deferred.resolve(interviewSetData);
                }, function (error) {
                    console.error(error);
                    deferred.reject();
                });

            return deferred.promise;
        };

        var getJobInterviewSetsMeta = function () {

            var deferred = $q.defer();

            InterviewV2API.getJobInterviewSetsInfo(self.brandId, self.job.id, self.isAQAAFServiceEnabled)
                .then(function (response) {
                    // if AQAAF job there must be an INTERVIEW SET ID
                    // and AQAAF jobs must be updated no created
                    // else create a new interview set with the defaults
                    var interviewSetData;
                    if (response.interview_set) {
                        interviewSetData = response.interview_set;
                        interviewSetData.defaults = false;
                    }
                    else {
                        interviewSetData = response.defaults;
                        interviewSetData.defaults = true;
                    }

                    deferred.resolve(interviewSetData);
                }, function (error) {
                    console.error(error);
                    deferred.reject();
                });

            return deferred.promise;
        };

        var onInit = function () {
            if (self.brandId && self.job.id && !self.job.isTemplate && self.job.status != 'UNKNOWN') {
                self.loading = true;

                getJobInterviewSetsMeta()
                    .then(function (setMeta) {

                        var neededData = {
                            brandId: self.brandId,
                            job: self.job,
                            selected_location: self.basicJobDetailsFormData && self.basicJobDetailsFormData.locations[0],
                            showInterviewWindow: source === "job_create_aqaaf",
                        };

                        if (self.isInterviewV2ServiceEnabled) {
                            neededData['interviewers'] = (self.interviewersFormData && self.interviewersFormData.interviewers) || [{user_id: hUser.getUser().id}];
                        }

                        // not defaults returned then there is an interview set and I will use it
                        if (!setMeta.defaults && setMeta.id) {

                            interviewSetId = setMeta.id;

                            if (self.isAQAAFServiceEnabled) {
                                self.settingsForm.load(neededData, setMeta);
                                self.calendarForm.load(neededData, setMeta);
                                _emitter.trigger('MANAGE_AVAILABILITY_GET_DATA', setMeta);
                                self.loading = false;
                            }
                            else {
                                getInterviewSetDetails()
                                    .then(function (setInfo) {
                                        self.settingsForm.load(neededData, setInfo);
                                        self.calendarForm.load(neededData, setInfo);
                                        _emitter.trigger('MANAGE_AVAILABILITY_GET_DATA', setInfo);
                                        self.loading = false;
                                        $scope.$digest();
                                    });
                            }

                        } else {
                            self.settingsForm.load(neededData, {});
                            self.calendarForm.load(neededData, {});
                            self.loading = false;
                        }

                        $scope.$digest();
                    });
            } else {
                var neededData = {
                    brandId: self.brandId,
                    showInterviewWindow: source === "job_create_aqaaf",
                };

                self.settingsForm.load(neededData, {});
                self.calendarForm.load(neededData, {});
            }
        };

        var updateInterviewSet = function (payload) {
            var defer = $q.defer();

            InterviewV2API.updateBrandInterviewSet(self.brandId, interviewSetId, payload)
                .then(function (response) {
                    defer.resolve({data: payload});
                }, function (error) {
                    console.error(error);
                    defer.reject(error);
                    $scope.$digest();
                });

            return defer.promise;
        };

        var createInterviewSet = function (payload) {
            var defer = $q.defer();

            switch (source) {
                case 'job_create_aqaaf':
                    payload['type'] = "AQAAF";
                    break;

                case 'job_create':
                    payload['type'] = "JOB";
                    break;

                default:
                    payload['type'] = "JOB";
            }

            if (self.isAQAAFServiceEnabled) {
                payload['type'] = "AQAAF";
            }

            payload['job_id'] = self.job.id;

            if (!payload.slots.length) {
                defer.resolve({});
            }
            else {
                InterviewV2API.saveBrandInterviewSet(self.brandId, payload)
                    .then(function (response) {
                        defer.resolve({data: payload});
                    }, function (error) {
                        console.error(error);

                        if (error && error.data && error.data.errors && error.data.errors[0] && error.data.errors[0].code === "INTERVIEWERS_HAVE_CONFIRMED_SLOTS") {
                            var message = error.data.errors[0].detail && error.data.errors[0].detail.message;
                            hAlert({
                                title: "Interview confirmed Slots",
                                text: message,
                                custom_class: 'rejection-templates-error-alert',
                                button: {
                                    text: $filter("translate")("Close")
                                }
                            });
                            defer.reject({error: {code: "INTERVIEWERS_HAVE_CONFIRMED_SLOTS"}});
                        } else {
                            defer.reject(error);
                        }
                        $scope.$digest();
                    });

            }

            return defer.promise;
        };

        self.getInterviewSettingsData = function () {
            return {
                interview_slot: (parseInt(self.calendarForm.getDuration())),
                interview_window: parseInt(self.calendarForm.getInterviewWindow()),
            };
        };

        var prepareFormData = function (res) {
            var defer = $q.defer();

            var settingsFormData = res[0];
            var calendarFormData = res[1];

            var location = (self.basicJobDetailsFormData && self.basicJobDetailsFormData.locations[0]) || settingsFormData.selected_location;
            var interviewWindow = getMinMaxWindow();
            var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            var payload = {
                allow_overlap: settingsFormData.interview_overlap,
                duration: (parseInt(self.calendarForm.getDuration()) * 60),
                slots: InterviewDataService.retrieveSlotsToSave(interviewWindow.min, interviewWindow.max),
                message:  {message: self.autoInviteMessage || settingsFormData.message},
                location: location,
                applied_timezone: timezone,
                category: self.autoInviteInterviewCategory || 'IN_PERSON',
            };

            if (self.autoInviteAttachments?.length) {
                payload.attachments = self.autoInviteAttachments;
            }

            if (self.autoInviteInterviewCategory === 'VIDEO_INTERVIEW') {
                payload['video_interview_link'] = self.autoInviteVideoLink;
            }

            if (self.isInterviewV2ServiceEnabled) {
                var interviewers = [];
                if (self.interviewersFormData && self.interviewersFormData.interviewers && self.interviewersFormData.interviewers.length) {
                    interviewers = _.map(self.interviewersFormData.interviewers, function (value) {
                        return { user_id: value.id };
                    });
                }

                payload['interviewers'] = interviewers;
            }

            if (interviewSetId) {
                updateInterviewSet(payload)
                    .then(function (data) {
                        defer.resolve({data: data.data});
                    });
            }
            else {
                if (self.forcedTemplates || payload.slots.length > 0) {
                    createInterviewSet(payload)
                        .then(function (data) {
                            defer.resolve({data: data.data});
                        })
                        .catch(function (error) {
                            defer.reject(error);
                        });
                }
                else {
                    defer.resolve({});
                }
            }

            return defer.promise;
        };

        self.loadJobId = function (jobId) {
            self.job = self.job || {};
            self.job.id = jobId;
        };

        self.isForcedTemplatesEnabled = function (isEnabled) {
            self.forcedTemplates = isEnabled;
            self.calendarForm.setForcedTemplatesServiceEnabled(isEnabled);
        };

        var updateAutoInviteMsg = function () {
            var interviewWindow = getMinMaxWindow();
            if (self.isAQAAFServiceEnabled && autoInvitesCount) {
                var tempSlots = InterviewDataService.retrieveSlotsToSave(interviewWindow.min, interviewWindow.max);
                if (interviewOverlap) {
                    self.autoInvitesCountMoreThanSlots = tempSlots.length < 1;
                } else {
                    self.autoInvitesCountMoreThanSlots = autoInvitesCount > tempSlots.length;
                }
            } else {
                self.autoInvitesCountMoreThanSlots = false;
            }
        };

        self.save = function () {

            var defer = $q.defer();
            self.saving = true;

            forms.saveAll(true)
                .then(function (res) {

                    prepareFormData(res)
                        .then(function (data) {
                            defer.resolve({data: data.data});
                        })
                        .catch(function (err) {
                            var errorCode = (err['error'] && err['error']['code']) || 'ERROR';
                            defer.reject({data: {code: errorCode}});
                        });

                    $scope.$digest();
                }, function (err) {
                    self.saving = false;
                    $scope.$evalAsync();
                    if (!interviewSetId && !self.forcedTemplates) {
                        defer.resolve({});
                    }
                    else {
                        defer.reject({data: {code: 'VALIDATION'}});
                    }
                });

            return defer.promise;
        };

        self.validate = function () {
            updateAutoInviteMsg();
            updateSlotsOutsideInterviewWindowMsg();
            if (self.autoInvitesCountMoreThanSlots || self.confirmedSlotsOutsideInterviewWindow) {
                return false;
            }

            if (!interviewSetId && !self.forcedTemplates) {
                // Always valid in this case
                return true;
            }

            return forms.validateAll(true);
        };

        self.setIsOptional = function (isOptional) {
            self.calendarForm.setOptional(isOptional);
        };

        var getMinMaxWindow = function () {
            var publishDate = (self.job && self.job.publish_date && !self.job.isTemplate)? moment(self.job.publish_date): moment();
            var endDate = self.job && self.job.end_date? moment(self.job.end_date): publishDate.clone().add(30, "days");

            if (self.job && self.job.activeDays == 'evergreen'){
                return {
                    min: !self.job.publish_date ? moment().endOf('day') : publishDate.clone(),
                    max: null,
                };
            }

            if (self.job && self.job.end_date) {
                endDate = moment(self.job.end_date);
            }
            else {
                var jobMaxTime = 30;

                if (self.job && self.job.life_time && self.job.life_time.max_life_time) {
                    jobMaxTime = self.job.life_time.max_life_time;
                }

                endDate = publishDate.clone().add(jobMaxTime, "days");
            }

            var interviewSettings = self.job && self.job.interview_settings || {};
            var interviewWindow = interviewSettings.interview_window || 365;

            var interviewAutoInviteSettings = self.isAQAAFServiceEnabled && interviewSettings['interview_auto_invite_settings'];
            var interviewRecession = (interviewAutoInviteSettings && interviewAutoInviteSettings['send_invitation_after_days_count']) || 1;

            var minNavDate = publishDate.clone();
            if (interviewAutoInviteSettings && interviewAutoInviteSettings['send_invitation_mode']) {
                if (interviewAutoInviteSettings['send_invitation_mode'] === 'AFTER_JOB_POST') {
                    minNavDate = publishDate.clone().add(interviewRecession, 'days').endOf('day');
                } else if (interviewAutoInviteSettings['send_invitation_mode'] === 'REAL_TIME') {
                    minNavDate = publishDate.clone();
                } else if (interviewAutoInviteSettings['send_invitation_mode'] === 'AFTER_JOB_EXPIRY') {
                    minNavDate = endDate.clone().add(interviewRecession, 'days').endOf('day');
                }
            }
            var maxNavDate = minNavDate.clone().add(interviewWindow, 'days');

            return {
                min: minNavDate,
                max: maxNavDate,
            };
        }

        self.drawInterviewSchedule = function () {
            var interviewWindow = getMinMaxWindow();
            var minNavDate = interviewWindow.min;
            var maxNavDate = interviewWindow.max;

            // Draw from minNavDate to MaxNavDate
            viewService.setAvailableSlotsPeriods(minNavDate, maxNavDate);

            var startDate = minNavDate.isBefore() ? moment() : minNavDate.clone().add(1, 'day');

            self.calendarForm.setViewedWeek(startDate);
            viewService.drawAll();
        };

        self.updateMinMax = function (publishDate, endDate, activeDays) {
            if (self.job) {
                self.job.publish_date = publishDate;
                self.job.end_date = endDate;
                self.job.activeDays = activeDays;
                self.drawInterviewSchedule();
            }
            else {
                console.warn("No job when trying to update min/max");
            }
            updateSlotsOutsideInterviewWindowMsg();
        };

        self.load = function (data) {

            self.job = data.job;

            if (data.brandId) {
                self.brandId = data.brandId;
            }

            self.loading = true;

            brandServices.checkAll(self.brandId, [
                brandServices.SERVICES.INTERVIEW_V2,
                brandServices.SERVICES.AQAAF
            ])
                .then(function (services) {

                    self.loading = false;

                    self.isInterviewV2ServiceEnabled = services[brandServices.SERVICES.INTERVIEW_V2];
                    self.isAQAAFServiceEnabled = services[brandServices.SERVICES.AQAAF];

                    if (data.basicJobDetailsFormData) {
                        self.basicJobDetailsFormData = data.basicJobDetailsFormData;
                    }

                    if (self.isInterviewV2ServiceEnabled) {
                        self.interviewersFormData = data.interviewersFormData;
                    }

                    if (self.job && self.job.interview_settings) {
                        if (self.job.interview_settings.interview_slot) {
                            self.calendarForm.setDuration(self.job.interview_settings.interview_slot);
                        }

                        if (self.job.interview_settings.interview_window) {
                            self.calendarForm.setInterviewWindow(self.job.interview_settings.interview_window);
                        }
                    }

                    onInit();
                });
        };

        self.loadJob = function (job, isTemplate, interviewersFormData, basicJobDetailsFormData) {
            self.load({
                job: job,
                interviewersFormData: interviewersFormData,
                basicJobDetailsFormData: basicJobDetailsFormData,
                brandId: job.Brand && job.Brand.id
            });
        };

        self.destroy = function () {
            self.settingsForm.destroy();
            self.calendarForm.destroy();
            $scope.settingsForm = null;
            $scope.calendarForm = null;
        };
    };

    interviewModule
        .service('InterviewManageAvailability', [
            'InterviewSettingsForm',
            'InterviewCalendarForm',
            'InterviewViewService',
            'InterviewDataService',
            'hUser',
            'brandServices',
            function (
                InterviewSettingsForm,
                InterviewCalendarForm,
                InterviewViewService,
                InterviewDataService,
                hUser,
                brandServices
            ) {

                return function (scope, source) {
                    return new InterviewManageAvailabilityFormController(
                        scope,
                        InterviewSettingsForm,
                        InterviewCalendarForm,
                        InterviewViewService,
                        InterviewDataService,
                        source,
                        hUser,
                        brandServices
                    );
                }
            }]);
})();
